export class RenaultMyServiceActionDTO {
    IdAction: string | null;
    Status: boolean;
    Title: string;
    StartDate: string;
    EndDate: string;
    Year: number;
    IsOpen: boolean;
}

export class RenaultMyServiceActionPriceDTO {
    IdPrice: string | null;
    IdAction: string;
    IdProductType: string;
    Units: number;
    Price: number;
}

export class RenaultMyServiceProductTypeDTO {
    IdProductType: string | null;
    ProductType: string;
    RelatedProduct: string;
    PricesCount: number;
}

export class RenaultMyServiceActionModelList {
    HasData: boolean;
    Available: RenaultMyServiceActionModel[];
    Historic: RenaultMyServiceActionModel[];
}

export class RenaultMyServiceActionModel {
    IdAction: string | null;
    Title: string;
    StartDate: string;
    EndDate: string;
    Year: number;
    IsOpen: boolean;
}

export class RenaultMyServiceActionRemunerationModel {
    DataList: RenaultMyServiceActionRemunerationList[];
    TotalRemuneration: string;
}

export class RenaultMyServiceActionRemunerationList {
    ProductType: string;
    TotalUnits: number;
    Price: string;
    TotalPrice: string;
    NextLevelUnits: number;
    NextLevelPrice: string;
}

export class RenaultUserMyServiceDataDTO {
    IdUser: string;
    Name: string | null;
    Surname: string | null;
    Dni: string | null;
    EmailPersonal: string | null;
    PhonePersonal: string | null;
    Birthdate: string | null;
    Address: string | null;
    Location: string | null;
    Cp: string | null;
    IdProvince: string | null;
    Province: string | null;
    LegalApproved: boolean;
}

export class RenaultMyServiceActionResult {
    GlobalResult: RenaultMyServiceActionResultGlobal;
    UsersResult: RenaultMyServiceActionResultUser[];
}

export class RenaultMyServiceActionResultGlobal {
    TotalPrice: string;
    Detail: RenaultMyServiceActionResultGlobalDetail[];
}

export class RenaultMyServiceActionResultGlobalDetail {
    ProductType: string;
    TotalUnits: number;
    TotalPrice: string;
}

export class RenaultMyServiceActionResultUser {
    Name: string;
    TotalPrice: string;
    Detail: RenaultMyServiceActionResultUserDetail[];
}

export class RenaultMyServiceActionResultUserDetail {
    ProductType: string;
    TotalUnits: number;
    Price: string;
    TotalPrice: string;
}